// "Client logo" block for success stories (Jason, 2026-10-04 7 PM).
// Shows the story's own `logo` field (Client logo) in full colour, right-aligned beside the
// Client/Industry facts list on desktop (box max 220x120, object-fit: contain) and stacked above it
// on phones (<= 768px). Renders nothing when the story has no logo, so the block can sit on every
// story. Decorative (alt=""): the client name is in the facts list right next to it.
// The block has no settings; editors can move or delete it like any other block.
import React from 'react';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import './StoryLogo.css';

const SCALES = ['mini', 'preview', 'teaser', 'large'];

export const StoryLogoView = ({ properties, metadata, isEditMode }) => {
  const content = metadata || properties || {};
  const logo = content.logo;
  if (!logo?.download) {
    return isEditMode ? (
      <div className="block arkusStoryLogo arkus-story-logo-empty">
        Client logo: none set (add one in the "Client logo" field). Nothing is shown to visitors.
      </div>
    ) : null;
  }
  const scales = logo.scales || {};
  const srcSet = SCALES.filter((s) => scales[s]?.download && scales[s].width)
    .map((s) => `${flattenToAppURL(scales[s].download)} ${scales[s].width}w`);
  srcSet.push(`${flattenToAppURL(logo.download)} ${logo.width}w`);
  const src = flattenToAppURL(scales.preview?.download || logo.download);
  return (
    <div className="block arkusStoryLogo">
      <figure className="arkus-story-logo">
        <img
          src={src}
          srcSet={srcSet.join(', ')}
          sizes="220px"
          alt=""
          width={logo.width}
          height={logo.height}
          loading="eager"
          decoding="async"
        />
      </figure>
    </div>
  );
};

export const StoryLogoEdit = (props) => <StoryLogoView {...props} isEditMode />;
